import { OneLinkTargetScreens } from "~/types/base";
import { useState } from "#imports";

export default function () {
  const { oneLink} = useAppConfig();

  const getBaseUrl = (): URL => {
    const baseUrl = ref('');
    const source = useCookie('_fm_source').value ?? useState('_fm_source').value;
    const campaign = useCookie('_fm_campaign').value ?? useState('_fm_campaign').value;

    if (source && source === 'reddit') {
      baseUrl.value = oneLink.redditUrl
    } else {
      baseUrl.value = oneLink.baseUrl;
    }

    return new URL(baseUrl.value);
  }

  const getAuthCoinshopLink = (ott: string|null, uuid: string|null): string => {
    const deep_link_sub2: string = JSON.stringify({
      redirect: OneLinkTargetScreens.Coinshop,
      token: ott,
      uuid: uuid
    });

    const url = getBaseUrl();
    url.searchParams.append('deep_link_value', 'ott_with_redirect');
    url.searchParams.append('deep_link_sub2', deep_link_sub2);

    return url.href;
  }

  const getAuthExploreLink = (ott: string|null, uuid: string|null): string => {
    const deep_link_sub2: string = JSON.stringify({
      redirect: OneLinkTargetScreens.Explore,
      token: ott,
      uuid: uuid
    });

    const url = getBaseUrl();
    url.searchParams.append('deep_link_value', 'ott_with_redirect');
    url.searchParams.append('deep_link_sub2', deep_link_sub2);

    return url.href;
  }

  const getAuthBookLink = (
      bookId: number,
      ott: string | null,
      uuid: string | null
  ): string => {
    const deep_link_sub2: string = JSON.stringify({
      redirect: OneLinkTargetScreens.BookSummary,
      book_id: bookId,
      token: ott,
      uuid: uuid
    });

    const url = getBaseUrl();
    url.searchParams.append('deep_link_value', 'ott_with_redirect');
    url.searchParams.append('deep_link_sub2', deep_link_sub2);

    return url.href;
  }

  return {
    getAuthCoinshopLink,
    getAuthExploreLink,
    getAuthBookLink
  }
}